<template>
  <div
    class="product-box-set"
    :class="{'product-box-set--open': isOpen}"
  >
    <div class="product-box-set__tile">
      <product-box-segment-header
        class="product-box-set__segment-header"
        :product-box-data="productBoxData"
        :product-link="productLink"
      />
      <product-box-wide-segment-image
        class="product-box-set__segment-image"
        :product-box-data="productBoxData"
        :settings="settingsWide"
        :img-src="imgSetSrc"
        :is-box-type-vertical="isBoxTypeVertical"
        :is-bottle="isBottle"
      />
      <div class="product-box-set__segment-button">
        <button
          class="product-box-set__button | button button--secondary"
          @click="isOpen = !isOpen"
        >
          {{ $t('product.set.productsInSet') }}
        </button>
      </div>
    </div>

    <transition name="vue-animation--fade">
      <product-box-list
        class="product-box-set__items"
        v-show="isOpen"
        :products="productBoxData.articlesInSet"
        list-type="box"
        :tracking-list="`${trackingAdditional.list} > ${productBoxData.name}`"
      />
    </transition>
  </div>
</template>

<script lang="ts">
  import ProductBox from '../productBox/productBox.vue';
  import ProductBoxWideSegmentImage from '../productBoxWide/ProductBoxWideSegmentImage.vue';
  import {ProductBoxWideSettings} from '../productBoxWide/productBoxWideSettings';
  import ProductBoxList from '../productBoxList/productBoxList.vue';
  import diContainer from '../../utilities/js/diContainer/diContainer';

  export default {
    name: 'ProductBoxSet',
    components: {
      ProductBoxList,
      ProductBoxWideSegmentImage
    },
    mixins: [ProductBox],

    data() {
      return {
        isOpen: false,
        settingsWide: diContainer.get('productBoxWideSettings') as ProductBoxWideSettings,
      }
    },

    computed: {
      imgSetSrc(): string[] {
        return this.productBoxData.images.length > 3
          ? [this.productBoxData.images[1].src, this.productBoxData.images[3].src]
          : [this.productBoxData.images[0].src];
      }
    }
  }
</script>
